import { TableFilterClub } from "../enums/common.enums";
import { tabsProp } from "../interfaces/chart.interface";
import {
  dataDaily,
  dataWeekly,
  dataMonthly,
  dataYearly,
  dataPie,
} from "../mocked/mocked.data";

export const tabsArr: tabsProp[] = [
  {
    id: "daily",
    title: "Daily",
    data: dataDaily,
  },
  {
    id: "weekly",
    title: "Weekly",
    data: dataWeekly,
  },
  {
    id: "monthly",
    title: "Monthly",
    data: dataMonthly,
  },
  {
    id: "yearly",
    title: "Yearly",
    data: dataYearly,
  },
];

export const clubTableArr: tabsProp[] = [
  {
    id: TableFilterClub.BALANCE,
    title: "Treasury Balance",
    data: TableFilterClub.BALANCE,
  },
  {
    id: TableFilterClub.FUNDRAISE,
    title: "Fundraise Completed",
    data: TableFilterClub.FUNDRAISE,
  },
  {
    id: TableFilterClub.MEMBERS,
    title: "Members",
    data: TableFilterClub.MEMBERS,
  },
  {
    id: TableFilterClub.NFT_TRANSACTIONS,
    title: "NFT Transactions",
    data: TableFilterClub.NFT_TRANSACTIONS,
  },
  {
    id: TableFilterClub.PROFIT,
    title: "Total profit / loss",
    data: TableFilterClub.PROFIT,
  },
  {
    id: TableFilterClub.PROPOSALS,
    title: "Total number of proposals",
    data: TableFilterClub.PROPOSALS,
  },
  {
    id: TableFilterClub.VAULT,
    title: "Total NFTs in the vault",
    data: TableFilterClub.VAULT,
  },
];

export const tabsPieArr: tabsProp[] = [
  {
    id: "daily",
    title: "Daily",
    data: dataPie,
  },
  {
    id: "weekly",
    title: "Weekly",
    data: dataPie,
  },
  {
    id: "monthly",
    title: "Monthly",
    data: dataPie,
  },
  {
    id: "yearly",
    title: "Yearly",
    data: dataPie,
  },
];

export default {};
